import React, { useState } from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Chip,
} from '@mui/material';
import { Share as ShareIcon } from '@mui/icons-material';
import { getScoreLabel, getScoreColor, getSavingsText } from '../../utils/comparisonScoring';
import { formatCurrency } from '../../utils/renewalHelpers';
import CoverageGapWarning from './CoverageGapWarning';
import ShareDialog from './ShareDialog';
import { FEATURES } from '../../config/features';
import t from '../../utils/renewalsTranslations';

export default function RenewalComparison({ currentPolicy, recommendation, onSwitch, onRenew, loading }) {
  const [shareOpen, setShareOpen] = useState(false);
  if (!recommendation) return null;
  const savingsText = getSavingsText(recommendation.savings_amount, recommendation.savings_percentage);
  const shareRec = {
    id: recommendation.id,
    policyId: currentPolicy?.id,
    policy_name: currentPolicy?.policy_name,
    policyName: currentPolicy?.policy_name,
    savings_amount: recommendation.savings_amount,
    savingsAmount: recommendation.savings_amount,
    insurer_name: recommendation.insurer_name,
    insurerName: recommendation.insurer_name,
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>{t('renewals.comparison.title')}</Typography>
      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>{t('renewals.comparison.current')}</TableCell>
              <TableCell>{t('renewals.comparison.recommended')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>{t('renewals.comparison.price')}</TableCell>
              <TableCell>{formatCurrency(currentPolicy?.premium_amount)}</TableCell>
              <TableCell>{formatCurrency(recommendation.recommended_premium)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>{t('renewals.comparison.savings')}</TableCell>
              <TableCell>—</TableCell>
              <TableCell>{savingsText || '—'}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>{t('renewals.comparison.score')}</TableCell>
              <TableCell>—</TableCell>
              <TableCell>
                <Chip size="small" label={getScoreLabel(recommendation.overall_score)} color={getScoreColor(recommendation.overall_score)} />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Product / Insurer</TableCell>
              <TableCell>{currentPolicy?.insurer_name}</TableCell>
              <TableCell>{recommendation.product_name} / {recommendation.insurer_name}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <CoverageGapWarning gapDays={recommendation.coverage_gap_days} />
      <Box sx={{ mt: 2, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
        <Button variant="contained" onClick={() => onSwitch?.(recommendation.id)} disabled={loading}>
          {t('renewals.comparison.switch')}
        </Button>
        <Button variant="outlined" onClick={() => onRenew?.()} disabled={loading}>
          {t('renewals.comparison.renew')}
        </Button>
        {FEATURES.shareRecommendations && (
          <Button variant="outlined" startIcon={<ShareIcon />} onClick={() => setShareOpen(true)}>
            {t('renewals.comparison.share')}
          </Button>
        )}
      </Box>
      <ShareDialog open={shareOpen} onClose={() => setShareOpen(false)} recommendation={shareRec} />
    </Box>
  );
}
